export default __webpack_public_path__ + "static/media/convox.8beff5da.svg";